import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { EmbryoService } from 'src/app/Services/Embryo.service';
import { environment } from 'src/environments/environment.prod';

@Component({
  selector: 'app-blog-details',
  templateUrl: './blog-details.component.html',
  styleUrls: ['./blog-details.component.scss']
})
export class BlogDetailsComponent implements OnInit {
	lang: any;
	fileSrc:any
  constructor(public embryoService: EmbryoService , private sanitizer: DomSanitizer) { 
    		  this.lang = localStorage.getItem("lang");
		    	this.embryoService.emitLang.subscribe((lang: any) => {
					this.lang = localStorage.getItem("lang");
           this.fileSrc = this.sanitizer.bypassSecurityTrustResourceUrl(
															environment.api + '/'+ this.lang + '/blog/headless-commerce-do-i-need-headless-commerce-2023'
													);
			});
  }

  ngOnInit(): void {
  }

}
